import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const ActivateCreditMonitoringMutation = gql`
  mutation ActivateCreditScoreMonitoringMutation(
    $input: ActivateCreditMonitoringInput
  ) {
    activateCreditMonitoring(input: $input) {
      ... on ActivateCreditMonitoringSuccess {
        success
      }
      ... on ActivateCreditMonitoringError {
        ...error
        __typename
      }
    }
  }
  ${error}
`;

export default ActivateCreditMonitoringMutation;
